import React from "react";
import PropTypes from "prop-types";

import { IconWrapper } from "./IconWrappers";

const CloseIcon = ({ color, onClick }) => (
  <IconWrapper onClick={onClick}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
    >
      <g>
        <polygon
          fill={color}
          points="25.5,85.8 50,61.3 74.5,85.8 85.8,74.5 61.3,50 85.8,25.5 74.5,14.2 50,38.7 25.5,14.2 14.2,25.5 38.7,50    14.2,74.5  "
        />
      </g>
    </svg>
  </IconWrapper>
);

CloseIcon.propTypes = {
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/CloseIcon.js